<template>
    <div
        class="mic-button"
        :class="{ active }"
        @click="$emit('click')"
        v-tippy="{ followCursor: true, placement: 'bottom-end' }"
        content='Click or Press CTRL + " for speech to text'
    >
        <div class="icon-wrapper">
            <i class="material-icons">keyboard_voice</i>
        </div>
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "MicButton",
    props: {
        active: {
            type: Boolean,
            default: false,
        },
    },
});
</script>
<style>
@-webkit-keyframes pulse-blue {
    0% {
        transform: scale(0.95);
        box-shadow: 0 0 0 0 rgba(52, 172, 224, 0.7);
    }

    70% {
        transform: scale(1);
        box-shadow: 0 0 0 10px rgba(52, 172, 224, 0);
    }

    100% {
        transform: scale(0.95);
        box-shadow: 0 0 0 0 rgba(52, 172, 224, 0);
    }
}

@keyframes pulse-blue {
    0% {
        transform: scale(0.95);
        box-shadow: 0 0 0 0 rgba(52, 172, 224, 0.7);
    }

    70% {
        transform: scale(1);
        box-shadow: 0 0 0 10px rgba(52, 172, 224, 0);
    }

    100% {
        transform: scale(0.95);
        box-shadow: 0 0 0 0 rgba(52, 172, 224, 0);
    }
}
</style>
<style scoped lang="scss">
.mic-button {
    position: absolute;
    width: 50px;
    height: 80px;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    //padding-top: 20px;
    cursor: pointer;
    color: var(--color-icon-info-default);

    &.active {
        .icon-wrapper {
            animation: pulse-blue 2s infinite;
            background: rgba(52, 172, 224, 1);
            box-shadow: 0 0 0 0 rgba(52, 172, 224, 1);
            border-radius: 50%;
            color: white;
        }
    }

    .icon-wrapper {
        transform: scale(1);
        display: flex;
        align-items: center;
        justify-content: center;
        width: 30px;
        height: 30px;
        border-radius: 50%;
    }
}
</style>
